const createAnalytics = (environment: 'development' | 'production') => {
  const analytics = (window.parafinAnalytics = window.parafinAnalytics || [])

  if (analytics.initialize) return

  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.')
    }
    return
  }

  analytics.invoked = true

  analytics.methods = ['identify', 'track']

  analytics.factory = (method: any) => {
    return function () {
      const args = Array.prototype.slice.call(arguments)
      args.unshift(method)
      analytics.push(args)
      return analytics
    }
  }

  for (const key of analytics.methods) {
    analytics[key] = analytics.factory(key)
  }

  analytics.load = () => {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://assets.parafin.com/js/segment.${environment}.js`

    const first = document.getElementsByTagName('script')[0]
    if (first.parentNode) {
      first.parentNode.insertBefore(script, first)
    }
  }

  const key = environment === 'production'
    ? 'klHdZwDmrfCsVxVHCGWCAy6s19zRPO50'
    : 'A1poUAjQgzGQd5DfiUPHC4v6Jjtyw87r'
  analytics.SNIPPET_VERSION = '4.13.2'
  analytics._writeKey = key
  analytics.load(key)

  return analytics
}

export default createAnalytics
